export default __webpack_public_path__ + "static/media/bars_medium.269475ec.svg";